module.exports = __webpack_public_path__ + "img/westminster_t2.b7e65d3b.jpg";